import { render, staticRenderFns } from "./EmbedModuleLayout.vue?vue&type=template&id=6467552e"
import script from "./EmbedModuleLayout.vue?vue&type=script&lang=js"
export * from "./EmbedModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports